import Seo from "@/components/Seo";
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import PageMasthead from "@/components/PageMasthead";
import { FadeUp, Stagger, StaggerItem } from "@/components/motion";
import { SOLUTIONS } from "@/content/site";

const Solutions = () => (
  <div data-testid="solutions-page">
    <Seo
      title="Solutions"
      path="/solutions"
      description="Reach engaged, high-intent education audiences through Which Media — advertising, sponsored content, awards partnerships and bespoke market intelligence."
    />
    <PageMasthead
      dark
      kicker="Our Solutions"
      titleLines={[{ text: "Intelligence for" }, { text: "everyone in", accent: false }, { text: "education", accent: true }]}
      standfirst="Whichever side of the sector you sit on — parent, advertiser, school owner, investor or lender — Which Media turns a decade of independent insight into decisions you can act on with confidence."
    />

    <section className="mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-24 space-y-20 md:space-y-28">
      {SOLUTIONS.map((s, i) => (
        <div key={s.key} className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2 lg:col-start-8" : ""}`}>
            <FadeUp>
              <span className="headline-xl text-7xl md:text-8xl text-primary/20">0{i + 1}</span>
              <p className="kicker mt-2 mb-4">{s.kicker}</p>
              <h2 className="headline text-3xl md:text-5xl uppercase text-ink leading-[1.02]">{s.title}</h2>
            </FadeUp>
          </div>
          <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
            <FadeUp delay={0.1}>
              <p className="text-lg md:text-xl leading-relaxed text-foreground/80">{s.body}</p>
              <Stagger className="mt-8 space-y-4">
                {s.points.map((p) => (
                  <StaggerItem key={p} className="flex items-start gap-3">
                    <span className="mt-1 shrink-0 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center">
                      <Check size={14} strokeWidth={3} />
                    </span>
                    <span className="text-[16px] font-medium text-ink">{p}</span>
                  </StaggerItem>
                ))}
              </Stagger>
            </FadeUp>
          </div>
        </div>
      ))}
    </section>

    <section className="bg-ink text-white">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-24 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
        <FadeUp>
          <h2 className="headline text-4xl md:text-6xl uppercase max-w-2xl">
            Let's build something that moves the sector
          </h2>
        </FadeUp>
        <Link to="/contact" className="shrink-0 inline-flex items-center gap-2 font-sans text-base font-bold bg-primary text-primary-foreground rounded-full pl-8 pr-6 py-4 hover:bg-white hover:text-ink transition-colors">
          Talk to our team <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  </div>
);

export default Solutions;
